var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-page',{attrs:{"id":"trial-management-app","image_source":_vm.image_source,"image_height":_vm.image_height}},[_c('trial-management-app',{ref:"trial-management-app",attrs:{"only_trial":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }